import { PermissionName } from '../../types/asset-permissions.types'
import { useAssetPermissionsState } from './useAssetPermissionsState'
import { useAuthState } from '../../../../hooks/useAuthState'
import { useMemo } from 'react'

export function useCurrentUsersAssetPermissions(
  assetId: string,
  isWhiteLabel?: boolean,
  isCodeSubdomain?: boolean
): PermissionName | null {
  const assetPermissionsState = useAssetPermissionsState(assetId, isWhiteLabel, isCodeSubdomain)
  const { jwt } = useAuthState()
  const permissionName = useMemo(() => {
    if (!assetPermissionsState || !assetPermissionsState?.currentPermissions) {
      return null
    }

    const permissionsAppliedToCurrentUser = assetPermissionsState.currentPermissions.filter(p => {
      return (
        p.entityId === jwt?.ithacaId || //users permission applies
        p.entityId === jwt?.org?.orgId || //org permission applies
        jwt?.org?.teams?.some(t => t.teamId === p.entityId) //some team permission applies
      )
    })
    const hasOwnerPermission: boolean = permissionsAppliedToCurrentUser.some(
      p => p.permissionName === PermissionName.OWNER
    )
    const hasEditorPermission: boolean = permissionsAppliedToCurrentUser.some(
      p => p.permissionName === PermissionName.EDITOR
    )
    const hasViewerPermission: boolean = permissionsAppliedToCurrentUser.some(
      p => p.permissionName === PermissionName.VIEWER
    )

    if (hasOwnerPermission) return PermissionName.OWNER
    if (hasEditorPermission) return PermissionName.EDITOR
    if (hasViewerPermission) return PermissionName.VIEWER

    return null
  }, [assetPermissionsState, jwt])
  return permissionName
}
